import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    data: null,
});

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.INVITE_NEW_USER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.INVITE_NEW_USER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload.success
            };
        case types.INVITE_NEW_USER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                data: action.payload.response,
            };
        case types.RESET_INVITE_NEW_USER:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}